import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBillWave,
  faSearch,
  faHandsHelping
} from "@fortawesome/free-solid-svg-icons";
import "./banner.css";

export default class BannerPrincipal extends Component {
  render() {
    return (
      <section
        style={{
          backgroundImage: `url(${this.props.imagem})`,
          width: "100%",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
        }}
      >
        <div
          style={{
            height: 500,
            position: "relative",
            backgroundColor: "rgba(0,0,0,.1)"
          }}
        >
          <TextoBannerPrincipal />
        </div>
        {/* <img src={this.props.imagem} /> */}
      </section>
    );
  }
}
class TextoBannerPrincipal extends Component {
  render() {
    return (
      <main className="texto-banner">
        <h1 id="titulo"> Atendimento gratuito e especializado? </h1>

        <h3 id="subtitulo">
          {" "}
          Se consulte com um de nossos médicos agora mesmo e comprove o
          atendimento de alta qualidade oferecido gratuitamente{" "}
        </h3>

        <Link id="comecar-link" to={"/signup"}>
          {" "}
          <button id="comecar" className="btn btn-primary btn-sm mb-1">
            {" "}
            Começar agora{" "}
          </button>{" "}
        </Link>

        {/* <h4 id="trablhe-consultor"> Trabalhe como consultor</h4> */}
      </main>
    );
  }
}

export class BannerComoFunciona extends Component {
  render() {
    return (
      <section className="banner-como-funciona">
        {/* <img src={this.props.imagem} /> */}
        <TextoBannerComoFunciona />
        <div className="absolute-wrapper">
          <div className="col-md-12">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-md-7 col-12 circulos">
                <div className="circulo first">
                  <div className="col-md-12 icon">
                    <FontAwesomeIcon icon={faMoneyBillWave} size="2x" />
                  </div>
                  <p>Se consulte gratuitamente</p>
                </div>

                <div className="circulo">
                  <div className="col-md-12 icon">
                    <FontAwesomeIcon icon={faSearch} size="2x" />
                  </div>
                  <p>Encontre seu especialista</p>
                </div>

                <div className="circulo">
                  <div className="col-md-12 icon">
                    <FontAwesomeIcon icon={faHandsHelping} size="2x" />
                  </div>
                  <p>Inicie seu atendimento</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

class TextoBannerComoFunciona extends Component {
  render() {
    return (
      <main className="texto-banner-como-funciona">
        <h3 id="subtitulo-como-funciona"> Encontre um </h3>
        <h1 id="titulo-como-funciona">Médico especializado </h1>
        <h4 id="trablhe-consultor-como-funciona">
          {" "}
          Especialistas disponíveis para começar agora mesmo
        </h4>
      </main>
    );
  }
}
